import 'babel-polyfill';
// import 'intl';
// import 'intl/locale-data/jsonp/en';
import dva from 'dva';
import createHistory from 'history/createBrowserHistory';
import createLoading from 'dva-loading';
import './assets/style/antd.min.css';
import registerServiceWorker from './registerServiceWorker';
import './assets/style/reset.less';
import './assets/style/frame.less';
import './assets/style/scss/index.scss';
import './utils/arms';
import './utils/ga';

// 1. Initialize
const app = dva({
  history: createHistory(),
  onError(e, dispatch) { // eslint-disable-line
    if (process.env.NODE_ENV !== 'production') {
      console.log('Global onError', e);
    }
    e.preventDefault();
  }
});

// 2. Plugins
app.use(createLoading({ effects: true }));

// 3. Register global model

require.context('./models/', true, /\.js$/).keys().forEach((file) => {
  // eslint-disable-next-line
  app.model(require(`./models/${file.slice(2)}`).default);
});

// 4. Router
app.router(require('./routes/index.js').default);

// 5. Start
app.start('#root');

registerServiceWorker();
